import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import Tooltip from '@clds/tooltip';
import { asStyledComponent } from '@clds/component-enhancer';
import { Icon } from '@cld/icon';
import { ButtonLink } from '@cld/button';

import { DropdownMenu } from '@cld/dropdown-menu';
import { messages } from '../../../../i18n';
import { MenuRoot } from './Menu.styles';

export interface MenuProps {
  isDropdownOpen: boolean;
  onDropdownOpenChange(visible: boolean): void;
  mainItems: ReactNode;
  dropdownItems?: ReactNode;
}

export const Menu = asStyledComponent(({ mainItems, dropdownItems, onDropdownOpenChange, isDropdownOpen, ...rest }: MenuProps) => {
  const { formatMessage } = useIntl();

  return (
    <MenuRoot forceVisible={isDropdownOpen} {...rest}>
      {mainItems}

      {dropdownItems && (
        <DropdownMenu
          onOpenedChange={onDropdownOpenChange}
          isOpened={isDropdownOpen}
          items={dropdownItems}
          getTooltipContainer={(element) => element.parentElement?.parentElement ?? document.body}
        >
          <Tooltip title={formatMessage(messages.menuIconTooltip)} placement="top">
            <ButtonLink data-test="transformation-menu-button">
              <Icon name="moreVert" size="md" color="contrastLow" />
            </ButtonLink>
          </Tooltip>
        </DropdownMenu>
      )}
    </MenuRoot>
  );
});
